import { createRandomSpinParams } from "../config/wheelConfig";
import { useWheelSettings } from "../context/WheelSettingsContext";

function SpinButton({ onSpin, disabled }) {
  const { settings } = useWheelSettings();

  const handleSpin = () => {
    const params = createRandomSpinParams(settings);
    onSpin(params);
  };

  return (
    <button
      onClick={handleSpin}
      disabled={disabled}
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "126px",
        height: "126px",
        padding: "0",
        fontSize: "28px",
        fontWeight: "700",
        letterSpacing: "0.08em",
        color: disabled ? "rgba(100, 160, 200, 0.4)" : "#d0f0ff",
        background: disabled
          ? "rgba(10, 30, 60, 0.4)"
          : "linear-gradient(135deg, rgba(20, 70, 140, 0.85) 0%, rgba(10, 40, 90, 0.9) 100%)",
        border: `1px solid ${disabled ? "rgba(80, 140, 200, 0.2)" : "rgba(80, 180, 255, 0.45)"}`,
        borderRadius: "50%",
        cursor: disabled ? "not-allowed" : "pointer",
        backdropFilter: "blur(8px)",
        boxShadow: disabled
          ? "none"
          : "0 0 24px rgba(0, 150, 255, 0.24), 0 5px 14px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(120, 200, 255, 0.18)",
        transition: "all 0.2s ease",
        outline: "none",
        overflow: "hidden",
        zIndex: 3,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.boxShadow = "0 0 35px rgba(0, 180, 255, 0.45), 0 4px 16px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(120, 200, 255, 0.2)";
          e.currentTarget.style.borderColor = "rgba(100, 200, 255, 0.7)";
          e.currentTarget.style.color = "#ffffff";
          e.currentTarget.style.transform = "translate(-50%, -50%) scale(1.03)";
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.boxShadow = "0 0 20px rgba(0, 150, 255, 0.2), 0 4px 12px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(120, 200, 255, 0.15)";
          e.currentTarget.style.borderColor = "rgba(80, 180, 255, 0.45)";
          e.currentTarget.style.color = "#d0f0ff";
          e.currentTarget.style.transform = "translate(-50%, -50%)";
        }
      }}
      onMouseDown={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = "translate(-50%, -50%) scale(0.98)";
          e.currentTarget.style.boxShadow = "0 0 12px rgba(0, 150, 255, 0.3), 0 2px 6px rgba(0, 0, 0, 0.4)";
        }
      }}
      onMouseUp={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = "translate(-50%, -50%) scale(1.03)";
        }
      }}
    >
      {/* Shimmer overlay */}
      <span
        style={{
          position: "absolute",
          top: 0, left: "-100%",
          width: "60%",
          height: "100%",
          background: "linear-gradient(90deg, transparent, rgba(180, 230, 255, 0.08), transparent)",
          transform: "skewX(-20deg)",
          animation: disabled ? "none" : "shimmer 3s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />
      <style>{`
        @keyframes shimmer {
          0%   { left: -100%; }
          60%  { left: 150%; }
          100% { left: 150%; }
        }
      `}</style>
      Spin
    </button>
  );
}

export default SpinButton;
